<!------------------------------

    Table Wrapper

------------------------------->

<sb-table-wrapper headline="{{'lang.headlines.campaigns' | translate}}" [itemsData]="campaignData"
                  [options]="options" (optionsChange)="requestDebounced($event)"
                  [loading]="loading" [isInIntegratedContext]="true"
                  [itemName]="'campaigns'">
  <!------------------------------

      Header More

------------------------------->
  <div header-more>
    <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
               classes="btn-default actionButtonMinWidth"
               (click)="requestDebounced()" [disabled]="loading" [loading]="loading">
      <sb-icon icon="refresh"></sb-icon>
    </sb-button>
    <a *ngPermissions="permissionService.Permission.campaign_list"
       [sbRouterLink]="util.RoutingID.campaigns" [queryParams]="{'company': getCompanyId()}">
      <button class="btn btn-primary">{{'lang.globals.showInList' | translate}}</button>
    </a>
  </div>
  <!------------------------------

         Table Header

   ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{'lang.globals.name' | translate}}
      </th>
      <th>
        {{'lang.globals.timingProgress' | translate}}
      </th>
      <th *ngPermissions="permissionService.Permission.ds_cm_reporting">
        {{'lang.globals.playoutPulse' | translate}}
      </th>
      <th class="text-end">{{'lang.globals.actions' | translate}}</th>
    </tr>
  </ng-template>
  <!------------------------------

        Table Body

  ------------------------------->
  <ng-template #tbody let-campaign>
    <tr>
      <td>
        <div class="d-flex align-items-center">
          <sb-action-required class="mr-4" [bookingStatus]="campaign.bookingStatus"></sb-action-required>
          <sb-comp-image-name-wrapper [still]="true" [medium]="campaign?.preview" [tooltipInterval]="campaign.interval">
            <sb-comp-link
              firstLine
              [title]="campaign.name | truncate : 23"
              [link]="util.RoutingID.commercials"
              [pathParams]="[{id: 'campaignID', value:campaign?.id}]"
              [tooltip]="'lang.globals.openDetails' | translate">
            </sb-comp-link>
            <span secondLine>
                  {{campaign?.commercialCount?.Present}} {{campaign?.commercialCount?.Present === 1 ? ('lang.globals.commercial'|translate) : ('lang.globals.commercials'|translate)}}
                </span>
            <span thirdLine [classes]="'d-xxxl-none'">{{campaign.customer.name}}</span>
          </sb-comp-image-name-wrapper>
        </div>
      </td>
      <td>
        <sb-progressbar [bigProgress]="false"
                        [width]="util.getTimeframePercentage(campaign?.from,campaign?.till)">
                    <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Future'"
                          class="blue font-weight-bold">{{'lang.globals.planned' | translate}}</span>
          <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Present'"
                class="green font-weight-bold">{{'lang.globals.running' | translate}}</span>
          <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Past'"
                class="grey font-weight-bold">{{'lang.globals.expired' | translate}}</span>
          <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Unknown'"
                class="grey font-weight-bold">{{'lang.globals.noTiming' | translate}}</span>
        </sb-progressbar>
        <div class="d-flex justify-content-between">
          <span style="width: 95px"
                class="text-start font-weight-bold">{{campaign?.from?.toString() | date: 'dd.MM.yy HH:mm'}}</span>
          <span style="width: 10px" class="mx-1 text-center">-</span>
          <span style="width: 95px"
                class="text-end font-weight-bold">{{campaign?.till?.toString() | date: 'dd.MM.yy HH:mm'}}</span>
        </div>
      </td>
      <td
        *ngIf="campaign && campaign?.reporting && campaign?.reporting?.loadingDone && permissionService.hasPermission(permissionService.Permission.ds_cm_reporting)"
        class="d-xxl-table-cell d-none" style="width: 180px;">
        <sb-line-small-chart [chartData]="campaign?.reporting">
        </sb-line-small-chart>
      </td>
      <td class="text-end">
        <a ngbTooltip="{{ 'lang.globals.openDetails' | translate }}" placement="left" container="body"
           [sbRouterLink]="util.RoutingID.commercials" [pathParams]="[{id: 'campaignID', value: campaign?.id }]">
          <sb-button classes="btn-hover-primary mr-1">
            <sb-icon icon="details"></sb-icon>
          </sb-button>
        </a>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper>
